import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { v4 as uuidV4 } from 'uuid';
// import { API_BASE_ADDRESS } from './api';

const apiClient: AxiosInstance = axios.create({});

apiClient.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const newConfig = { ...config };

    newConfig.headers = { ...config.headers };

    newConfig.headers['X-Request-ID'] = uuidV4();

    // const requestUrl = config.url;
    const jwtToken = localStorage.getItem('jwtToken') || '';
    // console.log('api get jwtToken:', jwtToken);
    newConfig.headers.authorization = jwtToken;

    return newConfig;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    // const requestUrl = response.config.url;
    const jwtToken = response.headers.authorization;
    if (jwtToken) {
      localStorage.setItem('jwtToken', jwtToken);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default apiClient;
